import * as React from 'react';

import {FormTextField} from './text-field';
import {TieredRadioButtonForm} from './tiered-radio-button-form';

type AdvancedProps = {
    value?: any;
    name: string;
    onChange: (...args: any) => any;

    nullOptionText?: string;

    anyOptionText?: string;
    isNumber: boolean;

    showContains?: boolean;
};

type Props = AdvancedProps & {
    isSimple: boolean;
};

export function FormString(props: Props) {
    if (props.isSimple) {
        return <FormStringSimple {...props} />;
    } else {
        return <FormStringAdvanced {...props} />;
    }
}

export function FormStringAdvanced(props: AdvancedProps) {
    const getFields = () => {
        const fields = [
            {
                id: 'Equals',
                value: 'Is exactly',
            },
        ];

        if (props.showContains !== false) {
            fields.push({
                id: 'Contains',
                value: 'Contains',
            });
        }

        if (props.anyOptionText) {
            fields.push({id: 'any', value: props.anyOptionText});
        }

        if (props.nullOptionText) {
            fields.push({id: 'null', value: props.nullOptionText});
        }

        return fields;
    };

    const newProps = {...props, getFields} as const;

    return <TieredRadioButtonForm {...newProps} />;
}

const FormStringSimple = (props: Props) => {
    return (
        <FormTextField
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            isNumber={props.isNumber}
        />
    );
};
